export default {
  color: "#096a8d",
  // color: "#031163",
};
